// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conversation {
  background-color: #f0f0f5; /* Light gray background similar to iOS */
  min-height: 100vh; 
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  /* padding-bottom: 20px; */
  width: 100%;
}

.conversation-header {
  align-items: center;
  padding: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #f1f1f1;
  border-bottom: 1px solid #ccc;
  width: 100vw;
  max-width: 414px;
}

.dock
{
  display: none;
}


.back-buttonConvo {
  background: none;
  border: none;
  font-size: 36px;
  cursor: pointer;
  color: #007aff; /* iOS blue for a consistent look */
  left: 10px;
  top: 5px;
  position: fixed;
}

.conversation-title {
  font-size: 18px;
  font-weight: bold;
}

.conversation-messages {
  flex: 1 1;
  padding: 10px;
  overflow-y: auto;
  background-color: #fff;
}

.message-item {
  margin-bottom: 10px;
}

.message-item.incoming {
  text-align: left;
  display: flex;
}

.message-item.outgoing {
  text-align: right;
  align-self: flex-end;
}

.message-item p {
  margin: 0;
  padding: 10px;
  border-radius: 10px;
  display: inline-block;
  max-width: 80%;
}

.message-item.incoming p {
  background-color: #63ce85 !important;
  align-self: flex-start;
}

.message-item.outgoing p {
  background-color: #007aff;
}


.message-body-incomingConvo {
  position: relative;
  background-color: #63ce85; /* Your incoming message color */
  border-radius: 18px;
  padding: 10px 20px;
  max-width: 80%;
  margin: 5px 0;
  margin-left: 15px;
  font-size: 18px;
  color: white;
  align-self: flex-start;
}

.message-body-incomingConvo::after {
  content: '';
  position: absolute;
  left: 1px; /* Adjust this value to move the tail left or right */
  bottom: -2px; /* Adjust this value to move the tail up or down */
  border-style: solid;
  border-width: 15px 15px 15px 0; /* Adjust size of the tail */
  border-color: #63ce85 transparent transparent ; /* Tail color */
  transform: translateY(50%);
  z-index: 1;
}


.message-body-outgoing {
  position: relative;
  background-color: #007aff; /* Your incoming message color */
  border-radius: 18px;
  padding: 10px 20px;
  max-width: 80%;
  margin: 5px 0;
  font-size: 18px;
  color: white;
  align-self: flex-end;
}

.message-body-outgoing::after {
  content: '';
  position: absolute;
  right: -1px; /* Adjust this value to move the tail left or right */
  bottom: 6px; /* Adjust this value to move the tail up or down */
  border-style: solid;
  border-width: 12px 12px 12px 0; /* Adjust size of the tail */
  border-color: transparent #007aff transparent transparent; /* Tail color */
  transform: translateY(50%);
  z-index: 1;
}

.message-time {
  color: #999;
  font-size: 12px;
  font-weight: 600;
  text-align: right;
  padding-right: 20px; /* Aligns with the right edge of the message bubble */
}

`, "",{"version":3,"sources":["webpack://./src/components/css/conversation.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB,EAAE,yCAAyC;EACpE,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;;AAGA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc,EAAE,mCAAmC;EACnD,UAAU;EACV,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,kBAAkB;EAClB,yBAAyB,EAAE,gCAAgC;EAC3D,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS,EAAE,qDAAqD;EAChE,YAAY,EAAE,kDAAkD;EAChE,mBAAmB;EACnB,8BAA8B,EAAE,4BAA4B;EAC5D,8CAA8C,EAAE,eAAe;EAC/D,0BAA0B;EAC1B,UAAU;AACZ;;;AAGA;EACE,kBAAkB;EAClB,yBAAyB,EAAE,gCAAgC;EAC3D,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW,EAAE,qDAAqD;EAClE,WAAW,EAAE,kDAAkD;EAC/D,mBAAmB;EACnB,8BAA8B,EAAE,4BAA4B;EAC5D,yDAAyD,EAAE,eAAe;EAC1E,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB,EAAE,qDAAqD;AAC5E","sourcesContent":[".conversation {\n  background-color: #f0f0f5; /* Light gray background similar to iOS */\n  min-height: 100vh; \n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  /* padding-bottom: 20px; */\n  width: 100%;\n}\n\n.conversation-header {\n  align-items: center;\n  padding: 10px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  background-color: #f1f1f1;\n  border-bottom: 1px solid #ccc;\n  width: 100vw;\n  max-width: 414px;\n}\n\n.dock\n{\n  display: none;\n}\n\n\n.back-buttonConvo {\n  background: none;\n  border: none;\n  font-size: 36px;\n  cursor: pointer;\n  color: #007aff; /* iOS blue for a consistent look */\n  left: 10px;\n  top: 5px;\n  position: fixed;\n}\n\n.conversation-title {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.conversation-messages {\n  flex: 1;\n  padding: 10px;\n  overflow-y: auto;\n  background-color: #fff;\n}\n\n.message-item {\n  margin-bottom: 10px;\n}\n\n.message-item.incoming {\n  text-align: left;\n  display: flex;\n}\n\n.message-item.outgoing {\n  text-align: right;\n  align-self: flex-end;\n}\n\n.message-item p {\n  margin: 0;\n  padding: 10px;\n  border-radius: 10px;\n  display: inline-block;\n  max-width: 80%;\n}\n\n.message-item.incoming p {\n  background-color: #63ce85 !important;\n  align-self: flex-start;\n}\n\n.message-item.outgoing p {\n  background-color: #007aff;\n}\n\n\n.message-body-incomingConvo {\n  position: relative;\n  background-color: #63ce85; /* Your incoming message color */\n  border-radius: 18px;\n  padding: 10px 20px;\n  max-width: 80%;\n  margin: 5px 0;\n  margin-left: 15px;\n  font-size: 18px;\n  color: white;\n  align-self: flex-start;\n}\n\n.message-body-incomingConvo::after {\n  content: '';\n  position: absolute;\n  left: 1px; /* Adjust this value to move the tail left or right */\n  bottom: -2px; /* Adjust this value to move the tail up or down */\n  border-style: solid;\n  border-width: 15px 15px 15px 0; /* Adjust size of the tail */\n  border-color: #63ce85 transparent transparent ; /* Tail color */\n  transform: translateY(50%);\n  z-index: 1;\n}\n\n\n.message-body-outgoing {\n  position: relative;\n  background-color: #007aff; /* Your incoming message color */\n  border-radius: 18px;\n  padding: 10px 20px;\n  max-width: 80%;\n  margin: 5px 0;\n  font-size: 18px;\n  color: white;\n  align-self: flex-end;\n}\n\n.message-body-outgoing::after {\n  content: '';\n  position: absolute;\n  right: -1px; /* Adjust this value to move the tail left or right */\n  bottom: 6px; /* Adjust this value to move the tail up or down */\n  border-style: solid;\n  border-width: 12px 12px 12px 0; /* Adjust size of the tail */\n  border-color: transparent #007aff transparent transparent; /* Tail color */\n  transform: translateY(50%);\n  z-index: 1;\n}\n\n.message-time {\n  color: #999;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: right;\n  padding-right: 20px; /* Aligns with the right edge of the message bubble */\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
